import { ColumnOptions } from '@chargeafter/providers';
import { secureHttpClient } from '../restClient';
import { atomFamily } from 'jotai/utils';
import { atom, useAtomValue } from 'jotai';

// GraphQL

const CollectionsFamily = atomFamily((collection: string) =>
  atom(async () => {
    const { columns } = await secureHttpClient.getOperate<{
      columns: ColumnOptions[];
    }>(
      {
        fileName: 'tableManager.ts',
        fetchingFunction: 'CollectionsFamily',
      },
      `dynamic/meta-data/${collection}`,
    );
    return columns as ColumnOptions[];
  }),
);

export const useGetColumns = (collection: string) => {
  return useAtomValue(CollectionsFamily(collection));
};

// REST
const CollectionsFamilyREST = atomFamily((collection: string) =>
  atom(async () => {
    const { columns } = await secureHttpClient.getOperate<{
      columns: ColumnOptions[];
    }>(
      {
        fileName: 'tableManager.ts',
        fetchingFunction: 'CollectionsFamilyREST',
      },
      `api/meta-data/${collection}`,
    );
    return columns as ColumnOptions[];
  }),
);

export const useGetColumnsREST = (collection: string) => {
  return useAtomValue(CollectionsFamilyREST(collection));
};
